// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "./" + ({"121":"vendor","544":"boundle"}[chunkId] || chunkId) + ".css";
};